import { City } from '@/store/modules/location/state';

// Chave própria, fora do namespace do cache de `query()` (`${queryName}${variablesHash}`):
// misturar os dois é justamente a armadilha do "dado velho" quando o cache é limpo.
const SELECTED_CITY_KEY = 'admissions-selected-city';

interface StoredSelectedCity {
  admissionId?: number;
  city: City;
}

// sessionStorage, não localStorage: isto é estado da sessão de preenchimento, não
// preferência durável. (O mock de `window.localStorage` dos testes também é parcial —
// só `getItem`/`setItem`/`clear`.)
export function saveSelectedCity(city: City, admissionId?: number): void {
  try {
    const record: StoredSelectedCity = { admissionId, city };

    window.sessionStorage.setItem(SELECTED_CITY_KEY, JSON.stringify(record));
  } catch {
    // storage bloqueado (modo privado, cota) degrada para o comportamento de hoje:
    // sem cidade persistida, o candidato volta para /selecao-de-cidade.
  }
}

export function readSelectedCity(admissionId?: number): City | undefined {
  try {
    const raw = window.sessionStorage.getItem(SELECTED_CITY_KEY);

    if (!raw) return undefined;

    const record: StoredSelectedCity = JSON.parse(raw);

    // registro de outra admissão não vale: a cidade salva não tem relação com a
    // admissão em curso.
    if (record?.admissionId !== admissionId) return undefined;

    const { city } = record;

    if (!city?.city && !city?.state) return undefined;

    return city;
  } catch {
    return undefined;
  }
}
